<section [ngClass]="dynamicClass">
  <div class="pb-container pb-mb-6 lg:pb-mb-7">
      <h2 class="pb-text-d-xl-m lg:pb-text-d-xl pb-font-serif pb-mb-2 lg:pb-mb-4 pb-text-color-brand" data-title="true">
          {{rendering?.fields?.Title?.value}}
      </h2>
      <div *ngIf="rendering?.fields?.Subtitle?.value" class="pb-text-lg-m lg:pb-text-lg">{{rendering?.fields?.Subtitle?.value}}</div>
  </div>
  <!-- Slider main container -->
  <div #CardSlider class="swiper pb-swiper-slider-mobile pb-mobile-swiper-fm">
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper  lg:pb-grid lg:pb-grid-cols-3 lg:pb-gap-x-6 lg:pb-gap-y-13 lg:!pb-translate-x-0">
      <!-- Slides -->
      <ng-container *ngFor="let card of rendering?.fields?.Cards; let i=index">
        <div class="swiper-slide !pb-w-[297px] lg:!pb-w-full !pb-h-auto" *ngIf="i<shownItems">
          <div class="pb-h-full !pb-justify-normal pb-card pb-card-product pb-card-product-with-img pb-theme--{{ theme }}">
            <a hybridHref href="{{card?.fields?.Link?.value?.href}}"
                class="pb-p-4 pb-card-top pb-relative pb-flex pb-justify-between pb-items-center"
                [ngClass]="card?.fields?.GreenProduct?.value ? energySave ? '!pb-bg-green-70 after:!pb-border-b-green-70' : '!pb-bg-olive-green-40 after:!pb-border-b-olive-green-40' : '' ">
                <h4 [ngClass]=" card?.fields?.OnlineIssueing?.value ? 'pb-w-1/2' : '' " class="pb-text-xs-m lg:pb-text-xs pb-font-bold">
                    {{card?.fields?.ProductType?.value}}
                </h4>
                <a *ngIf="card?.fields?.OnlineIssueing?.value" href="#" class="pb-text-xs-m lg:pb-text-xs">{{ 'GetOnline' |translate }}</a>
            </a>
            <a hybridHref href="{{card?.fields?.Link?.value?.href}}" class="pb-card-product-img-placeholder">
                <img src="{{ card?.fields?.FaceCardImage?.value?.src ? card?.fields?.FaceCardImage?.value?.src : card?.fields?.ImageMobile?.value?.src}}" alt="{{ card?.FaceCardImage?.value ? card?.FaceCardImage?.value?.alt : card?.ImageMobile?.value?.alt }}" class="!pb-filter-none"/>
            </a>
            <div class="pb-p-5 pb-card-bottom pb-flex pb-flex-col pb-h-full">

                <a hybridHref href="{{card?.fields?.Link?.value?.href}}">
                    <h3 class="pb-text-h-xs-m lg:pb-text-h-sm pb-font-bold pb-mb-2 pb-line-clamp-3 pb-h-[3lh]">
                        {{card?.fields?.Title?.value}}
                    </h3>
                    <div class="pb-line-clamp-3 pb-h-[3lh]"> {{card?.fields?.Subtitle?.value}}
                    </div>
                </a>
                <hr *ngIf="card?.fields?.KeyFeaturesProductGallery?.value" class="pb-mt-4 pb-mb-2" />
                <a hybridHref href="{{card?.fields?.Link?.value?.href}}" class="pb-article pb-article-piraeus"
                    [innerHTML]="card?.fields?.KeyFeaturesProductGallery?.value"></a>

            </div>
        </div>
        </div>
      </ng-container>
    </div>
  </div>
  <button *ngIf="shownItems < rendering?.fields?.Cards?.length" type="button" (click)="shownItems = shownItems + 3" class="pb-btn pb-btn-secondary pb-mx-auto pb-mt-8">{{'show-more' | translate}}</button>
</section>